import { InputSelect } from '@abbott-components/core';
import { Stack, Typography, Box, FormControl } from '@mui/material';
import { PagePermissionLevel } from '../../Shared/Enums/pagePermissionLevel';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import getRoleKeys from '../../Shared/jsonSchemaUtilities/getRoleKeys';
import formatName from '../formatName';

export default ({
  properties,
  isDisabled
}: {
  properties: JSONSchema7Properties;
  isDisabled?: boolean;
}) => {
  const roleKeys = getRoleKeys(properties);
  return (
    <>
      {roleKeys.length > 0 && (
        <Stack spacing={1}>
          <Typography fontWeight="bold">Visibility</Typography>
          {roleKeys.map((roleKey) => (
            <Stack direction="row" spacing={2} key={roleKey}>
              <Box width={150} alignSelf="center">
                <Typography>{properties[roleKey].title}</Typography>
              </Box>
              <Box>
                <FormControl size="small" sx={{ width: 120 }}>
                  <InputSelect
                    name={formatName(properties[roleKey]?.$id as string)}
                    defaultValue={properties[roleKey].default as string}
                    isDisabled={isDisabled}
                  >
                    <InputSelect.Option value={PagePermissionLevel.Edit}>
                      Edit
                    </InputSelect.Option>
                    <InputSelect.Option value={PagePermissionLevel.ReadOnly}>
                      Read Only
                    </InputSelect.Option>
                    <InputSelect.Option value={PagePermissionLevel.NoAccess}>
                      No Access
                    </InputSelect.Option>
                  </InputSelect>
                </FormControl>
              </Box>
            </Stack>
          ))}
        </Stack>
      )}
    </>
  );
};
